/**
 * CRM permission keys (catalog `crm.*`, docs/contracts/crm.md §6). The UI hides what a key does not allow; the API checks
 * the same keys and, for leads, accounts, opportunities, activities and cases, the owner / team visibility (P7).
 */
export const crmPermissions = {
  leadView: "crm.lead.view",
  leadCreate: "crm.lead.create",
  leadUpdate: "crm.lead.update",
  leadDelete: "crm.lead.delete",
  leadHistory: "crm.lead.history",
  leadConvert: "crm.lead.convert",
  accountView: "crm.account.view",
  accountCreate: "crm.account.create",
  accountUpdate: "crm.account.update",
  accountDelete: "crm.account.delete",
  accountHistory: "crm.account.history",
  contactView: "crm.contact.view",
  contactCreate: "crm.contact.create",
  contactUpdate: "crm.contact.update",
  contactDelete: "crm.contact.delete",
  activityView: "crm.activity.view",
  activityCreate: "crm.activity.create",
  activityUpdate: "crm.activity.update",
  activityDelete: "crm.activity.delete",
  opportunityView: "crm.opportunity.view",
  opportunityCreate: "crm.opportunity.create",
  opportunityUpdate: "crm.opportunity.update",
  opportunityDelete: "crm.opportunity.delete",
  opportunityHistory: "crm.opportunity.history",
  opportunityReopen: "crm.opportunity.reopen",
  appointmentView: "crm.appointment.view",
  appointmentCreate: "crm.appointment.create",
  appointmentUpdate: "crm.appointment.update",
  resourceView: "crm.appointment_resource.view",
  resourceUpdate: "crm.appointment_resource.update",
  collectionView: "crm.collection.view",
  collectionCreate: "crm.collection.create",
  collectionUpdate: "crm.collection.update",
  caseView: "crm.case.view",
  caseCreate: "crm.case.create",
  caseUpdate: "crm.case.update",
  caseDelete: "crm.case.delete",
  caseHistory: "crm.case.history",
  caseQuality: "crm.case.quality",
  caseCreditNote: "crm.case.credit_note",
  visitView: "crm.visit.view",
  visitCreate: "crm.visit.create",
  visitUpdate: "crm.visit.update",
  visitDelete: "crm.visit.delete",
  visitViewLocation: "crm.visit.view_location",
  targetView: "crm.target.view",
  targetCreate: "crm.target.create",
  targetUpdate: "crm.target.update",
  targetDelete: "crm.target.delete",
  targetHistory: "crm.target.history",
  targetReward: "crm.target.reward",
  segmentView: "crm.segment.view",
  segmentCreate: "crm.segment.create",
  segmentUpdate: "crm.segment.update",
  segmentDelete: "crm.segment.delete",
  setupView: "crm.setup.view",
  setupUpdate: "crm.setup.update",
  recordViewAll: "crm.record.view_all",
  privacyView: "crm.privacy.view",
  privacyErase: "crm.privacy.erase",
  reportView: "crm.report.view",
} as const;

/** Plan module of the CRM (optional, P6). */
export const crmModule = "crm";

/** The CRM settings group (`/platform/settings/crm`). */
export const crmSettingsGroup = "crm";

/** Record types of the CRM (Work tasks, forms and checklists on a record). */
export const crmRecordTypes = {
  lead: "crm.lead",
  account: "crm.account",
  opportunity: "crm.opportunity",
  case: "crm.case",
} as const;
